import React, { useState, useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { FavoriteBorder, Favorite } from '@mui/icons-material';
import './style/CardProductSlider.css';
import { CartContext } from './CartContext';
import { FavoriteContext } from './FavoriteContext'; // Импортируем контекст избранного

const CardProductSlider = ({ product, openModal }) => {
    const [isFavorite, setIsFavorite] = useState(false);
    const [showAddedMessage, setShowAddedMessage] = useState(false);
    const [showFavoriteMessage, setShowFavoriteMessage] = useState(false);
    const { addToCart } = useContext(CartContext);
    const { addToFavorites, removeFromFavorites, favorites } = useContext(FavoriteContext);

    useEffect(() => {
        setIsFavorite(favorites.some(fav => fav.id === product.id));
    }, [favorites, product.id]);

    const toggleFavorite = () => {
        if (isFavorite) {
            removeFromFavorites(product.id);
        } else {
            addToFavorites(product);
            setShowFavoriteMessage(true);
            setTimeout(() => {
                setShowFavoriteMessage(false);
            }, 2000);
        }
        setIsFavorite(!isFavorite);
    };

    const handleAddToCart = () => {
        addToCart(product);
        setShowAddedMessage(true);
        setTimeout(() => {
            setShowAddedMessage(false);
        }, 2000);
    };

    useEffect(() => {
        if (showAddedMessage) {
            const timer = setTimeout(() => {
                setShowAddedMessage(false);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [showAddedMessage]);

    return (
        <>
            <div className="card-product-slider-basic-content">
                <div 
                    className="card-product-slider-img-container" 
                    style={{ 
                        backgroundImage: `url(${process.env.REACT_APP_IMAGES_URL}/${product.product_photo})`, 
                        backgroundSize: 'contain',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <div onClick={() => openModal(product)} style={{ cursor: 'pointer' }}>
                        <div className="img-button-block">
                            {/* Пустой div для сохранения структуры */}
                        </div>
                    </div>
                    <div className="card-product-slider-favorite-icons-container">
                        <IconButton onClick={toggleFavorite} className="card-product-slider-favorite-icons-button">
                            {isFavorite ? <Favorite color="error" /> : <FavoriteBorder />}
                        </IconButton>
                    </div>
                </div>
                <div className="card-product-slider-name-container">
                    <div className="card-product-slider-name-block">
                        <span className="card-product-slider-tovar-name" title={product.name}>{product.name}</span>
                    </div>
                </div>
                <div className="card-product-slider-button-container">
                    <div className="card-product-slider-basic-button">
                        <button onClick={handleAddToCart} className="card-product-slider-button-knopka">
                            <ShoppingCartIcon />
                            <span className="price">{product.price} T</span>
                        </button>
                    </div>
                </div>
            </div>
            {showAddedMessage && ReactDOM.createPortal(
                <div className="global-added-message">Товар добавлен в корзину</div>,
                document.body
            )}
            {showFavoriteMessage && ReactDOM.createPortal(
                <div className="global-favorite-message">Товар добавлен в избранное</div>,
                document.body
            )}
        </>
    );
};

export default CardProductSlider;
